import UUID from 'util/UUID';
import * as i18n from 'i18next';
import { DeviceType, Theme } from 'shared/models';
import { makePIContainers } from './makePIContainers';
import { makeEcsContainers } from './makeEcsContainers';
import { makeDmgContainers } from './makeDmgContainers';

export function makeNewTheme(displayName: string, deviceType: DeviceType | null, width: number, height: number, uploaded: boolean, requirements: any = {}, isNorthAmerica: boolean, t: i18n.TFunction): Theme {
    const containerId = UUID.generate();

    const { piContainers = [], piAssets = {} } =
        requirements.pi
            ? makePIContainers(width, height, deviceType, isNorthAmerica, t)
            : {};

    const { dmgContainers = [], dmgAssets = {} } =
        requirements.pi
            ? makeDmgContainers(width, height, isNorthAmerica, t)
            : {};

    const { ecsContainers = [], ecsAssets = {} } =
        requirements.ecs
            ? makeEcsContainers(width, height, deviceType, isNorthAmerica, t)
            : {};

    return {
        id: UUID.generate(),
        lastSaved: undefined,
        width,
        height,
        displayName,
        containers: uploaded ? {} : {
            [containerId]: {
                id: containerId,
                displayName: t('THEME_EDITOR.BACKGROUND'),
                left: 0,
                top: 0,
                width: 1,
                height: 1,
                assetOrder: [],
                backgroundColor: '#007FFF',
                borderColor: 'transparent',
                borderThickness: 0,
                opacity: 100,
            },
            ...piContainers.reduce((all, c) => ({
                ...all,
                [c.id]: c,
            }), {}),
            ...dmgContainers.reduce((all, c) => ({
                ...all,
                [c.id]: c,
            }), {}),
            ...ecsContainers.reduce((all, c) => ({
                ...all,
                [c.id]: c,
            }), {}),
        },
        containerOrder: uploaded ? [] : [
            containerId,
            ...piContainers.map(c => c.id),
            ...dmgContainers.map(c => c.id),
            ...ecsContainers.map(c => c.id),
        ],
        assets: {
            ...piAssets,
            ...dmgAssets,
            ...ecsAssets,
        },
        options: {},
        uploaded,
        published: null,
        url: null,
        requirements,
        userId: null,
        size: null,
    };
}
